/* eslint-disable @next/next/no-img-element */
import React from 'react'
import styled from 'styled-components'
import { Subject } from 'interfaces/Subject'
import { colorToCssFilter } from 'lib/features/color'
import { Body2 } from '../../../stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import useMedia from 'lib/hooks/useMedia'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import { formatSubjectLabel, getSubjectColorByCategory } from 'lib/formatting/subjects'

interface Props {
    subject: Subject
    isSelected?: boolean
    to?: string
}

const Element = styled.div<{
    readonly iconColorFilter: string
}>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100px;
    padding: 10px;
    gap: 5px;
    height: 75px;
    cursor: pointer;
    p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    & .icon {
        display: flex;
        justify-content: center;
        filter: ${(props) => props.iconColorFilter};
    }
    @media (max-width: 750px) {
        width: 85px;
    }
`

const MinimalistSubjectBody = (props: Props) => {
    const md = useMedia(deviceSize.md)
    const iconColorFilter = colorToCssFilter(getSubjectColorByCategory(props.subject.colorCategory))

    return (
        <Element iconColorFilter={iconColorFilter} key={props.subject.id}>
            <div className="icon">
                <img src={props.subject.iconUrl} alt={props.subject.name} width={25} height={25} />
            </div>

            <Body2
                color={theme.colors.subtitleBlack}
                fontFamily="var(--font-inter)"
                fontWeight={400}
                fontSize={md ? 12 : 13}
                textAlign="center"
            >
                {formatSubjectLabel(props.subject)}
            </Body2>
        </Element>
    )
}

export default MinimalistSubjectBody
